import clientUploadAsset from './client-upload-asset';
import clientUploadAssets from './client-upload-assets';
import createMediaGalleryAssetsFromExternalSources from './create-media-gallery-assets-from-external-sources';
import createMediaGalleryAssets from './create-media-gallery-assets';
import fileSizeLimitReached from './file-size-limit-reached';

export default {
  clientUploadAsset,
  clientUploadAssets,
  createMediaGalleryAssets,
  fileSizeLimitReached,
  createMediaGalleryAssetsFromExternalSources,
};
